import { defineSlotRecipe } from '@chakra-ui/react'

export const formSlotRecipe = defineSlotRecipe({
  slots: ['container', 'requiredIndicator', 'helperText'],
  base: {
    container: {
      fontWeight: 400,
    },
  },
})

// import { ComponentStyleConfig } from '@chakra-ui/react'

// export const formTheme: ComponentStyleConfig = {
//   parts: ['container', 'requiredIndicator', 'helperText'],
//   baseStyle: {
//     container: {
//       label: {
//         fontWeight: 400,
//       },
//     },
//   },
// }
